import { useMemo } from 'react';
import ChartElement from '../../../Common/ChartElement';

export default function Histogram({ installersStock, type }) {
    const chartType = type;

    const chartData = useMemo( () => {
        if(installersStock.length > 0){
            return installersStock.map( installer => ({
                name : installer.installer_name,
                Allocated : installer.total_allocated,
                Installed : installer.total_installed,
                Remaining : installer.total_remaining
            }))
        }
        return []
    }, [installersStock])

    return (
        <div className="mt-4 bg-white p-3 rounded shadow-sm">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0 text-capitalize">{chartType} Inventory Insights</h5>
            </div>
            <div className="overflow-auto">
                {chartData.length > 0 ? (
                    <ChartElement chartData={chartData} />
                ) : (
                    <div className="text-center text-muted py-4">
                        No installer data available
                    </div>
                )}
            </div>
        </div>
    );
} 